export enum LinkTarget {
  SELF = '_self',
  BLANK = '_blank',
  PARENT = '_parent',
  TOP = '_top',
}

export enum LinkSize {
  default = 'default',
  md = 'md',
}
